module.exports = __webpack_public_path__ + "img/camp01_actived.418100a7.png";